import type { RoomDef } from '../../../sim/types.ts';

/**
 * DEV TEST ROOM — not part of ROOMS (src/content/rooms/index.ts), so it carries
 * no solvability-harness obligation and does not count against the Round 1 room
 * budget (brief §14). It exists to try the Warden out.
 *
 * Load it with ?room=warden-test (see src/ui/useGame.ts).
 *
 * Layout, left to right: spawn → TailCharm (the skill's ammo) → the Warden's
 * starting position → Sunshard (the item kill) → Moonseed → Portal. The Warden
 * chases on sight exactly like a Drifter, so there is room to try three things:
 * wall it off with a cast, snipe it with the Tail skill once charged, or run
 * past it to the Sunshard and clear the room in one pickup.
 */
export const wardenTest: RoomDef = {
  id: 'test-warden',
  name: 'Warden Test',
  map: [
    '################',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '################',
    '################',
  ],
  spawn: { x: 2.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [
    { kind: 'tailcharm', tx: 4, ty: 9 },
    { kind: 'sunshard', tx: 10, ty: 9 },
    { kind: 'moonseed', tx: 13, ty: 9 },
  ],
  chimera: [{ kind: 'warden', x: 8, y: 9 }],
};
